import React, { ComponentPropsWithRef, forwardRef } from 'react'
import block from 'bem-cn'

import './Badge.scss'

const b = block('badge')

export enum BadgeVariant {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
}

export type BadgeProps = ComponentPropsWithRef<'div'> & {
  text?: React.ReactNode
  variant?: BadgeVariant
}

export const Badge: React.FC<BadgeProps> = forwardRef<HTMLDivElement, BadgeProps>(
  ({ text, className, variant = BadgeVariant.INFO, children, ...rest }, ref) => (
      <div {...rest} ref={ref} className={b('content').mix(className, variant)}>
        {text || children}
      </div>
    ),
)

Badge.displayName = 'Badge'
